/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { firstValueFrom } from "rxjs";

import { HttpClient, HttpContext } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ApiConfiguration } from "../api-configuration";
import { BaseService } from "../base-service";
import { getAllCustomers } from "../fn/customer/get-all-customers";
import { GetAllCustomers$Params } from "../fn/customer/get-all-customers";
import { getCustomerContactPersons } from "../fn/customer/get-customer-contact-persons";
import { GetCustomerContactPersons$Params } from "../fn/customer/get-customer-contact-persons";
import { upsertCustomerSubscriptionDescription } from "../fn/customer/upsert-customer-subscription-description";
import { UpsertCustomerSubscriptionDescription$Params } from "../fn/customer/upsert-customer-subscription-description";
import { upsertCustomerSubscriptionDescription_1 } from "../fn/customer/upsert-customer-subscription-description-1";
import { UpsertCustomerSubscriptionDescription_1$Params } from "../fn/customer/upsert-customer-subscription-description-1";
import { ContactOutput } from "../models/contact-output";
import { Customer } from "../models/customer";
import { StrictHttpResponse } from "../strict-http-response";

@Injectable({ providedIn: "root" })
export class CustomerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllCustomers()` */
  static readonly GetAllCustomersPath = "/dashboard/customers/";

  /**
   * Get All Customers.
   *
   * Get all customers visible to current user.
   *
   * Returns:
   *     List of customers that can be viewed by the user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllCustomers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllCustomers$Response(
    params?: GetAllCustomers$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<Array<Customer>>> {
    const obs = getAllCustomers(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get All Customers.
   *
   * Get all customers visible to current user.
   *
   * Returns:
   *     List of customers that can be viewed by the user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllCustomers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllCustomers(params?: GetAllCustomers$Params, context?: HttpContext): Promise<Array<Customer>> {
    const resp = this.getAllCustomers$Response(params, context);
    return resp.then((r: StrictHttpResponse<Array<Customer>>): Array<Customer> => r.body);
  }

  /** Path part for operation `upsertCustomerSubscriptionDescription()` */
  static readonly UpsertCustomerSubscriptionDescriptionPath =
    "/dashboard/customers/{customerId}/descriptions/{subscriptionId}";

  /**
   * Upsert Customer Subscription Description.
   *
   * Create or update a Customer Subscription Description.
   *
   * Args:
   *     description: Description object.
   *
   * Returns:
   *     Ok
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertCustomerSubscriptionDescription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertCustomerSubscriptionDescription$Response(
    params: UpsertCustomerSubscriptionDescription$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<void>> {
    const obs = upsertCustomerSubscriptionDescription(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Upsert Customer Subscription Description.
   *
   * Create or update a Customer Subscription Description.
   *
   * Args:
   *     description: Description object.
   *
   * Returns:
   *     Ok
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upsertCustomerSubscriptionDescription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertCustomerSubscriptionDescription(
    params: UpsertCustomerSubscriptionDescription$Params,
    context?: HttpContext,
  ): Promise<void> {
    const resp = this.upsertCustomerSubscriptionDescription$Response(params, context);
    return resp.then((r: StrictHttpResponse<void>): void => r.body);
  }

  /** Path part for operation `upsertCustomerSubscriptionDescription_1()` */
  static readonly UpsertCustomerSubscriptionDescription_1Path = "/dashboard/customers/descriptions";

  /**
   * Upsert Customer Subscription Description.
   *
   * Create or update a Customer Subscription Description.
   *
   * Args:
   *     description: Description object.
   *
   * Returns:
   *     Ok
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertCustomerSubscriptionDescription_1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertCustomerSubscriptionDescription_1$Response(
    params: UpsertCustomerSubscriptionDescription_1$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<any>> {
    const obs = upsertCustomerSubscriptionDescription_1(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Upsert Customer Subscription Description.
   *
   * Create or update a Customer Subscription Description.
   *
   * Args:
   *     description: Description object.
   *
   * Returns:
   *     Ok
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upsertCustomerSubscriptionDescription_1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertCustomerSubscriptionDescription_1(
    params: UpsertCustomerSubscriptionDescription_1$Params,
    context?: HttpContext,
  ): Promise<any> {
    const resp = this.upsertCustomerSubscriptionDescription_1$Response(params, context);
    return resp.then((r: StrictHttpResponse<any>): any => r.body);
  }

  /** Path part for operation `getCustomerContactPersons()` */
  static readonly GetCustomerContactPersonsPath = "/dashboard/customers/{customer_id}/contact_persons";

  /**
   * Get Customer Contact Persons.
   *
   * Retrieve details of contact persons of a organization. Logged-in user must belong to the org.
   *
   * Args:
   *     customer_id: Customer ID
   *     current_user: SurfOIDCUserModel
   *     db: Database handle
   *
   * Returns:
   *     List of contacts.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomerContactPersons()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerContactPersons$Response(
    params: GetCustomerContactPersons$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<Array<ContactOutput>>> {
    const obs = getCustomerContactPersons(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get Customer Contact Persons.
   *
   * Retrieve details of contact persons of a organization. Logged-in user must belong to the org.
   *
   * Args:
   *     customer_id: Customer ID
   *     current_user: SurfOIDCUserModel
   *     db: Database handle
   *
   * Returns:
   *     List of contacts.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCustomerContactPersons$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerContactPersons(
    params: GetCustomerContactPersons$Params,
    context?: HttpContext,
  ): Promise<Array<ContactOutput>> {
    const resp = this.getCustomerContactPersons$Response(params, context);
    return resp.then((r: StrictHttpResponse<Array<ContactOutput>>): Array<ContactOutput> => r.body);
  }
}
